import { ButtonBase } from '@material-ui/core'
import { ArrowBackIos, ArrowForwardIos } from '@material-ui/icons'
import { any, func } from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const CardMobileWraperStyled = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ButtonContainer = styled.div`
  width: 18%;
  display: flex;
  justify-content: center;
  svg {
    font-size: 20px;
  }
`

const Body = styled.div`
  flex-grow: 1;
`
const Button = styled(ButtonBase)`
  background: var(--second);
  color: #fff;
  width: 35px;
  height: 35px;
  border-radius: 50%;
`
const CardMobileWraper = props => {
  return (
    <CardMobileWraperStyled>
      <ButtonContainer style={{ justifyContent: 'flex-start' }}>
        <Button onClick={props.onBack}><ArrowBackIos style={{ marginRight: '-7px' }} /></Button>
      </ButtonContainer>
      <Body>
        {props.children}
      </Body>
      <ButtonContainer style={{ justifyContent: 'flex-end' }}>
        <Button onClick={props.onNext}><ArrowForwardIos /></Button>
      </ButtonContainer>
    </CardMobileWraperStyled>
  )
}

CardMobileWraper.propTypes = {
  children: any,
  onNext: func,
  onBack: func
}

export default CardMobileWraper
